import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import "@fontsource/poppins";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/600-italic.css";
import { GOOGLE_CLIENT_ID } from "./app/config";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const googleClientId = GOOGLE_CLIENT_ID || "";

root.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </GoogleOAuthProvider>,
);
